<!--For Laptop and Above View-->
<div fxLayout="column" class="primary-bg">
	<div fxLayout="row" fxFill fxLayoutAlign="flex-end" fxHide.lt-md>
		<img
			src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/topHeartHomepage/public"
		/>
	</div>
	<div fxLayout="row" fxHide.gt-sm ngClass="p-b-m">
		<img
			src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/topHeartMobile/public"
		/>
	</div>
	<div
		fxLayout.gt-sm="row"
		fxLayout.lt-md="column"
		fxLayoutAlign="center center"
	>
		<div
			fxLayout="column"
			fxFlex="50%"
			ngClass.gt-md="p-l-xxl m-l-xxl"
			ngClass.gt-sm="p-l-xxl"
			fxLayoutAlign.lt-md="center center"
		>
			<div
				fxLayout="row"
				ngClass.lt-md="p-l-xxl p-r-xxl"
				ngClass.lt-sm="p-l-xs p-r-xs"
			>
				<h2
					class="white-text"
					ngClass.lt-md="text-align-center"
					i18n="@@homepage_sub_footer_startFund_joinWhyDonate"
				>
					Join WhyDonate's Fundraising Community
				</h2>
			</div>
			<div fxLayout="row" ngClass="p-t-s">
				<app-start-fundraiser-button
					buttonType="homepage3"
				></app-start-fundraiser-button>
			</div>
		</div>
		<div
			fxLayout="column"
			fxFlex="20%"
			ngClass.gt-sm="p-l-xs"
			ngClass.lt-md="p-t-xl m-t-s"
			fxLayoutAlign.gt-sm="center"
			fxLayoutAlign.lt-md="center center"
		>
			<div fxLayout="row" ngClass="p-b-m">
				<span
					class="white-text mat-card-title font-large"
					style="font-family: roboto"
					i18n="@@homepage_sub_footer_startFund_websiteVisitorsCount"
				>
					1M+
				</span>
			</div>
			<div fxLayout="row">
				<p
					class="white-text mat-subtitle"
					i18n="@@homepage_sub_footer_startFund_websiteVisitors"
				>
					Website Visitors / Month
				</p>
			</div>
			<div
				fxLayout="row"
				ngClass.gt-sm="p-b-m p-t-xl"
				ngClass.lt-md="p-b-m p-t-l"
			>
				<span
					class="white-text mat-card-title font-large"
					style="font-family: roboto"
				>
					{{ totalFundriasers | number }}+
				</span>
			</div>
			<div fxLayout="row">
				<p
					class="white-text mat-subtitle"
					i18n="@@homepage_sub_footer_startFund_fundraisersStarted"
				>
					Fundraisers Started
				</p>
			</div>
		</div>
		<div
			fxLayout="column"
			fxFlex="30%"
			fxLayoutAlign.gt-sm="center"
			fxLayoutAlign.lt-md="center center"
			ngClass.lt-md="p-t-l"
		>
			<div fxLayout="row" ngClass="p-b-m">
				<span
					class="white-text mat-card-title font-large"
					style="font-family: roboto"
				>
					{{ activeDonors | number }}+
				</span>
			</div>
			<div fxLayout="row">
				<p
					class="white-text mat-subtitle"
					i18n="@@homepage_sub_footer_startFund_activeDonors"
				>
					Active Donors
				</p>
			</div>
			<div
				fxLayout="row"
				fxLayoutAlign="flex-start center"
				fxLayoutGap="4%"
				ngClass.gt-sm="p-b-m p-t-xl"
				ngClass.lt-md="p-b-m p-t-l"
			>
				<span
					class="white-text mat-card-title font-large"
					style="font-family: roboto"
					i18n="@@homepage_sub_footer_startFund_rating"
				>
					4.8/5
				</span>
				<img
					height="17px"
					src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/fiveStarsNew/public"
				/>
			</div>
			<div fxLayout="row">
				<p
					class="white-text mat-subtitle"
					i18n="@@homepage_sub_footer_startFund_ratingContent"
				>
					Top Rated On Trustpilot and Google
				</p>
			</div>
		</div>
	</div>
	<div fxLayout="row" fxFill fxLayoutAlign="flex-start" fxHide.lt-md>
		<img
			src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/bottomHeartHomepage/public"
		/>
	</div>
	<div fxLayout="row" fxHide.gt-sm fxLayoutAlign="flex-end" ngClass="p-t-m">
		<img
			src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/bottomHeartMobile/public"
		/>
	</div>
</div>
